// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestEnvironmentSpecCluster } from './RequestEnvironmentSpecCluster';
import {
  RequestEnvironmentSpecClusterFromJSON,
  RequestEnvironmentSpecClusterFromJSONTyped,
  RequestEnvironmentSpecClusterToJSON,
  RequestEnvironmentSpecClusterToJSONTyped,
} from './RequestEnvironmentSpecCluster';
import type { RequestEnvironmentSpecComponent } from './RequestEnvironmentSpecComponent';
import {
  RequestEnvironmentSpecComponentFromJSON,
  RequestEnvironmentSpecComponentFromJSONTyped,
  RequestEnvironmentSpecComponentToJSON,
  RequestEnvironmentSpecComponentToJSONTyped,
} from './RequestEnvironmentSpecComponent';
import type { RequestOwnerIdentifier } from './RequestOwnerIdentifier';
import {
  RequestOwnerIdentifierFromJSON,
  RequestOwnerIdentifierFromJSONTyped,
  RequestOwnerIdentifierToJSON,
  RequestOwnerIdentifierToJSONTyped,
} from './RequestOwnerIdentifier';

/**
 *
 * @export
 * @interface RequestEnvironmentSpec
 */
export interface RequestEnvironmentSpec {
  /**
   *
   * @type {Array<RequestEnvironmentSpecCluster>}
   * @memberof RequestEnvironmentSpec
   */
  clusters?: Array<RequestEnvironmentSpecCluster>;
  /**
   *
   * @type {Array<RequestEnvironmentSpecComponent>}
   * @memberof RequestEnvironmentSpec
   */
  components?: Array<RequestEnvironmentSpecComponent>;
  /**
   *
   * @type {Array<RequestOwnerIdentifier>}
   * @memberof RequestEnvironmentSpec
   */
  ownerIdentifiers?: Array<RequestOwnerIdentifier>;
}

/**
 * Check if a given object implements the RequestEnvironmentSpec interface.
 */
export function instanceOfRequestEnvironmentSpec(
  value: object,
): value is RequestEnvironmentSpec {
  return true;
}

export function RequestEnvironmentSpecFromJSON(
  json: any,
): RequestEnvironmentSpec {
  return RequestEnvironmentSpecFromJSONTyped(json, false);
}

export function RequestEnvironmentSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestEnvironmentSpec {
  if (json == null) {
    return json;
  }
  return {
    clusters:
      json['clusters'] == null
        ? undefined
        : (json['clusters'] as Array<any>).map(
            RequestEnvironmentSpecClusterFromJSON,
          ),
    components:
      json['components'] == null
        ? undefined
        : (json['components'] as Array<any>).map(
            RequestEnvironmentSpecComponentFromJSON,
          ),
    ownerIdentifiers:
      json['owner_identifiers'] == null
        ? undefined
        : (json['owner_identifiers'] as Array<any>).map(
            RequestOwnerIdentifierFromJSON,
          ),
  };
}

export function RequestEnvironmentSpecToJSON(
  json: any,
): RequestEnvironmentSpec {
  return RequestEnvironmentSpecToJSONTyped(json, false);
}

export function RequestEnvironmentSpecToJSONTyped(
  value?: RequestEnvironmentSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    clusters:
      value['clusters'] == null
        ? undefined
        : (value['clusters'] as Array<any>).map(
            RequestEnvironmentSpecClusterToJSON,
          ),
    components:
      value['components'] == null
        ? undefined
        : (value['components'] as Array<any>).map(
            RequestEnvironmentSpecComponentToJSON,
          ),
    owner_identifiers:
      value['ownerIdentifiers'] == null
        ? undefined
        : (value['ownerIdentifiers'] as Array<any>).map(
            RequestOwnerIdentifierToJSON,
          ),
  };
}
